module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_E_5.67fe7822.mp3";